// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__11jKU","title":"Info_title__o6beG","selects":"Info_selects__1o1j0","requiredAsterisk":"Info_requiredAsterisk__1bXqk"};